var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:[
    !_vm.isMobileViewPort
      ? 'text-h5 d-inline-block font-weight-medium'
      : 'text-subtitle-1 font-weight-medium',
    _vm.subtitleOnTop ? 'mt-0 mb-8' : 'mb-0' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }